import React from "react";
import { X } from "react-feather";
import Modal from "react-modal";
import ModalContent from "../../../common/Modal/ModalContent";
import { useEffect, useState } from "react";
import api from "../../../utils/api";
import ReactStars from "react-rating-stars-component";
import Spinner from "../../../common/Spinner/Spinner";
import { toast } from "react-toastify";
import { Button } from "../../../common/Button/Button";

export default function UserFeedbackModal(props)
{
    let data= [
      {
        "service_id":202893,
        "service_name":"Online Starter Pack",
        "customer_details":{"name":"Abhijit Pimparkar","email":"abhijit08sep@mailinator.com","contact_number":"9860443660"},
        "facilitator_name":"",
        "feedback_given":[
          {
            "que":"How would you rate your overall experience with our service partner?*",
            "ans":"5"
          },
          {
            "que":"What did you like about our service?*",
            "ans":"Timely Delivery"
          },
          {
            "que":"What did you like about our service?*",
            "ans":"Quick Response"
          },
          {
            "que":"What did you like about our service?*",
            "ans":"Cost-effective"
          }
        ],
        "csat":"positive"
      }]

     const [
        userServiceFeedbackData,
        setUserServiceFeedbackData,
      ] = useState();

      const [isLoading, setLoading] = useState(false);

      useEffect(() => {
          if(props.isOpen)
          {
              /*if(props.sEmailAddress)
              {
                setLoading(true);
                api.getUserAllServiceFeedbackData({sEmailAddress: props.sEmailAddress,nUserId:props.nUserId})
                .then((d) => {
                    setUserServiceFeedbackData(d.data.data);
                    setLoading(false);
                });
              }
            
              if(props.nResourceInstanceId)
              {
                setLoading(true);
                api.getUserServiceFeedbackData({nResourceInstanceId: props.nResourceInstanceId})
                .then((d) => {
                  setUserServiceFeedbackData(d.data.data);
                  setLoading(false);
                });
              }*/

              

              if(props.nResourceInstanceId&&props.refExternalServicePartnerEmailIDForFeedback)
              {
                let filterParameters={}
                filterParameters.search_value=props.nResourceInstanceId;
                filterParameters.EmailAddress = props.refExternalServicePartnerEmailIDForFeedback;

                setLoading(true);	
                const { tempServices } = api.getCustomerFeedbackList(filterParameters)
                .then(({ data }) => {
                    setLoading(false);
                    if(data)
                    {
                      setUserServiceFeedbackData(data);                     
                    }
                    else
                    {
                        toast("no data found.", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                  }).catch((error) =>
                    {
                        setLoading(false);
                        if(error.response.data.detail)
                        {
                            toast(String(error.response.data.detail), {
                                autoClose: 5000,
                                type: toast.TYPE.ERROR,
                            });
                        }
                        else if(error.response.data.message)
                        {
                            toast(String(error.response.data.message), {
                                autoClose: 5000,
                                type: toast.TYPE.ERROR,
                            });
                        }
                        else
                        {
                            toast("Internal server error", {
                                autoClose: 5000,
                                type: toast.TYPE.ERROR,
                            });
                        }            
                    });

              }
          }
       
      }, [props.isOpen]);

      const getServiceName =(key)=>{
        const _array = key.split('##');
        if(_array[1])
        {
          return _array[1];
        }
        else
        {
          if(props.nResourceInstanceId)
          {
            return props.sServiceNameForFeedback;
          }
        }

        return "";
        
      }

      const renderQuestions = (original) => {
        return original.feedback_given.map((feedback,i) => {
            return(
                <>
                    {
                        i===0?
                        <div className="conv-mb15">
                            <label className="feedback-question-label">{feedback.que}</label>
                            <ReactStars
                                className={"star-border"}
                                count={5}
                                size={25}
                                color="white"
                                activeColor="#76287C"
                                value={feedback.ans||0}
                                edit={false}
                            />
                        </div>
                        :
                        <div className="conv-mb15">
                            <label className="feedback-question-label">{feedback.que}</label>
                            <label className="feedback-ans-label">{feedback.ans}</label>
                        </div>
                    }
                </>
            )
          })
      }

      const onSendFeedbackSMS = async () => {
        try 
        {
          setLoading(true);
          if(props.nResourceInstanceId) 
          {
            var payload={nResourceInstanceId:props.nResourceInstanceId}
            let s=payload;
            const { data: _ignore_ } = await api.sendFeedbackLinkToUser(payload);
            toast("Feedback link sent to user successfully.", {
              autoClose: 5000,
              type: toast.TYPE.SUCCESS,
            });
          }
        } 
        catch (error) 
        {
          toast("Something went wrong. Contact webadmin support.", {
            autoClose: 5000,
            type: toast.TYPE.ERROR,
          });
        } 
        finally 
        {		
          setLoading(false);
        }
      };

      return (
        <Modal
          isOpen={props.isOpen}
          onRequestClose={props.toggleModal}
          ariaHideApp={false}
          className="conv-width-50p p-5 conv-ml350"

        >
          <ModalContent>
            <div className="p-2 modals-headers-bar">
              <span>User Feedback</span>
              <button
                type="button"
                className="close"
                aria-label="Close"
                onClick={props.toggleModal}
              >
                <X style={{ pointerEvents: "none" }} color="white" />
              </button>
            </div>
            <div
              className={`modal-body ${isLoading && "set-opacity"}`}
              style={{height: "350px",backgroundColor:"#ececec" }}
            >
              {
                userServiceFeedbackData ? 
                (
                  userServiceFeedbackData.length==0?
                  (
                    <Button onClick={onSendFeedbackSMS}
                      style={{marginRight:"10px",marginTop:"10px"}}>
                      Send Feedback Link
                    </Button>
                  ):
                  (
                    userServiceFeedbackData.map((item,i) => (
                        <div
                            style={{marginBottom:"10px"}}>
                            <h5>
                                {item.service_name}
                            </h5>
                           {renderQuestions(item)}
                        </div>
                    
                    ))
                  )                    
                ) 
                : 
                (
                  <Button onClick={onSendFeedbackSMS}
                    style={{marginRight:"10px",marginTop:"10px"}}>
                    Send Feedback Link
                  </Button>
                )     
              }
              {isLoading && <Spinner className="top" />}
            </div>
          </ModalContent>
        </Modal>
      );
}